import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, Observable, switchMap } from 'rxjs';
import { TokenAuthService } from './token-auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommissionRateTemplateApprovalDto } from '../components/configuration/models/commission-rate-tier.models';

@Injectable({
  providedIn: 'root'
})
export class CommissionRateTemplateService {

  constructor(public tokenAuthService: TokenAuthService,
    private httpClient: HttpClient,
  ) { }
 
   private readonly commissionRateTemplate_Url = `${environment.base_URL}${environment.contributorCommissionRateTemplate_URL}`;

  getCommissionRateTemplates(): Observable<any> {
    const url = `${this.commissionRateTemplate_Url}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }


    getCommissionRateTemplatesById(id: number): Observable<any> {
    const url = `${this.commissionRateTemplate_Url}/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  submitCommissionRateTemplateForApproval(commissionRateTemplateDto: CommissionRateTemplateApprovalDto): Observable<any> {
    const url = `${this.commissionRateTemplate_Url}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any[]>(url, commissionRateTemplateDto, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }


  updateCommissionRateTemplate(id: number, commissionRateTemplateDto: CommissionRateTemplateApprovalDto): Observable<any> {
    const url = `${this.commissionRateTemplate_Url}/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.put<any[]>(url, commissionRateTemplateDto, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  deleteCommissionRateTemplate(id: number): Observable<any> {
    const url = `${this.commissionRateTemplate_Url}/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.delete<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }


  getPendingCommissionRateTemplates(): Observable<any> {
    const url = `${this.commissionRateTemplate_Url}/pending`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  approveCommissionRateTemplate(id: number): Observable<any> {
    const url = `${this.commissionRateTemplate_Url}/approve/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any[]>(url, {}, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }


  rejectCommissionRateTemplate(id: number): Observable<any> {
    const url = `${this.commissionRateTemplate_Url}/reject/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any[]>(url, {}, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  viewContributorCommissionRateTemplatePendingApprovals(id: any): Observable<any> {
    const url = `${this.commissionRateTemplate_Url}/pending-approval/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  getContributionPeriods(): Observable<any[]> {
    const url = `${this.commissionRateTemplate_Url}/contribution-periods`;

    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }


}
